import React, { useState } from 'react';
import { MessageSquare, ThumbsUp, Clock } from 'lucide-react';

const SORA = "'Sora', system-ui, sans-serif";
const MANROPE = "'Manrope', system-ui, sans-serif";

const ThreadsList = ({ threads = [], onThreadClick, compact = false }) => {
  const [hoveredThread, setHoveredThread] = useState(null);

  return (
    <div style={{ fontFamily: MANROPE }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: compact ? 'center' : 'flex-start', gap: '8px', marginBottom: '14px' }}>
        <MessageSquare size={16} color="#93c5fd" />
        <span style={{ color: '#FFFFFF', fontSize: '14px', fontWeight: '700', fontFamily: SORA }}>Discussions</span>
        <span style={{ color: '#6f6b7d', fontSize: '12px' }}>({threads.length})</span>
      </div>

      {/* Thread List */}
      {threads.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {threads.slice(0, 8).map((thread, index) => {
            const isHovered = hoveredThread === index;

            return (
              <div
                key={thread.id || index}
                onClick={() => onThreadClick && onThreadClick(thread.slug)}
                style={{
                  padding: '12px',
                  background: isHovered ? 'rgba(139, 92, 246, 0.1)' : 'transparent',
                  borderRadius: '10px', cursor: 'pointer', transition: 'all 0.15s ease',
                }}
                onMouseEnter={() => setHoveredThread(index)}
                onMouseLeave={() => setHoveredThread(null)}
              >
                {/* Title */}
                <p style={{
                  color: '#FFFFFF', fontSize: '13px', fontWeight: '500', margin: 0, marginBottom: '6px',
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {thread.title}
                </p>

                {/* Meta */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  {thread.category && (
                    <span style={{
                      padding: '2px 8px', background: 'rgba(139, 92, 246, 0.15)',
                      borderRadius: '6px', color: '#c4b5fd', fontSize: '10px', fontWeight: '700',
                      textTransform: 'uppercase',
                    }}>
                      {thread.category}
                    </span>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6f6b7d' }}>
                    <MessageSquare size={11} />
                    <span style={{ fontSize: '11px' }}>{thread.replyCount || 0}</span>
                  </div>
                  {thread.likeCount !== undefined && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6f6b7d' }}>
                      <ThumbsUp size={11} />
                      <span style={{ fontSize: '11px' }}>{thread.likeCount}</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6f6b7d', marginLeft: 'auto' }}>
                    <Clock size={11} />
                    <span style={{ fontSize: '10px' }}>{formatDate(thread.lastActivity || thread.createdAt)}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '30px 10px' }}>
          <MessageSquare size={24} color="#6f6b7d" style={{ opacity: 0.5, marginBottom: '8px' }} />
          <p style={{ color: '#6f6b7d', fontSize: '12px', margin: 0 }}>No discussions yet</p>
        </div>
      )}
    </div>
  );
};

const formatDate = (dateString) => {
  if (!dateString) return 'recently';
  const diffMinutes = Math.floor((Date.now() - new Date(dateString)) / 60000);
  if (diffMinutes < 60) return `${diffMinutes}m`;
  if (diffMinutes < 1440) return `${Math.floor(diffMinutes / 60)}h`;
  if (diffMinutes < 10080) return `${Math.floor(diffMinutes / 1440)}d`;
  return `${Math.floor(diffMinutes / 10080)}w`;
};

export default ThreadsList;
